<swiper-container class="product-item-1 swiper-container" [appSwiper]="config" init="false" >
  @for (product of product; track product) {
    <swiper-slide class="swiper-slide">
      <mat-card appearance="outlined" class="fx-col">
        <div class="fx-col">
          @if (!contentLoaded) {
            <ngx-skeleton-loader loadingText="Ziplingo"
              count="1"
              [theme]="{ width: '180px', 'border-radius': '0', height: '180px' }"
            ></ngx-skeleton-loader>
          }
          @if (!contentLoaded) {
            <ngx-skeleton-loader loadingText="Ziplingo"
              count="2"
              [theme]="{ 'border-radius': '0', height: '20px', width: '180px'  }"
            ></ngx-skeleton-loader>
          }
        </div>
        @if (contentLoaded) {
          <div class="product-img">
            <a class="product-link" [routerLink]="['/product', product.ItemID]">
              <img [default]="'assets/images/product/no-img.png'" [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+product.ImageUrl" alt="">
            </a>
          </div>
        }
        <div class="product-info-wrapper">
          @if (contentLoaded) {
            <span class="category">{{product.Category.Name}}</span>
          }
          @if (contentLoaded) {
            <div class="title-wrap">
              <h4>{{product?.ProductName}}</h4>
            </div>
          }
          @if (contentLoaded) {
            <div class="price-wrap fx-row fx-main-between fx-cross-center">
              <div class="stars">
                <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
              </div>
              <p>${{product.Discounts[0].Prices[0].Price | currency : companyService.selectedCurrency.CurrencyCode}}</p>
            </div>
          }
          @if (contentLoaded) {
            <div class="btn-wrap fx-row fx-main-between fx-cross-center">
              <a (click)="addToCart(product)" mat-raised-button color="primary">ADD TO CART <mat-icon iconPositionEnd class="mat-icon-lg mat-icon material-icons">shopping_cart</mat-icon></a>
            </div>
          }
          <div class="icons fx-col">
            <a (click)="openProductDialog(product)"><mat-icon>remove_red_eye</mat-icon></a>
            <a (click)="addToCompare(product)"><mat-icon>cached</mat-icon></a>
          </div>
        </div>
      </mat-card>
    </swiper-slide>
  }

  <button slot="container-end" mat-mini-fab class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
  <button slot="container-end" mat-mini-fab class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
</swiper-container>

